module.exports = __webpack_public_path__ + "static/img/Phil_Davis_desktop.dcd5fc8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Phil_Davis_desktop.jpg
// module id = jrgw
// module chunks = 0